import { render, staticRenderFns } from "./DialogAmigos.vue?vue&type=template&id=fe158abc&scoped=true&"
import script from "./DialogAmigos.vue?vue&type=script&lang=js&"
export * from "./DialogAmigos.vue?vue&type=script&lang=js&"
import style0 from "./DialogAmigos.vue?vue&type=style&index=0&id=fe158abc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe158abc",
  null
  
)

export default component.exports